import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const ericssonNETargetInfoTemplateFIX: FormTemplate = {
  version: '1.0.1',
  name: 'Ericsson NE Target Info',
  key: 'ERICSSON_NE_TARGET_INFO',
  general: {
    metadata: {
      layout: {
        rows: [
          [
            'targetDeliveryTemplate',
          ],

        ],
      },
    },
    fields: {
      targetDeliveryTemplate: {
        type: 'select',
        label: 'Target Delivery Template',
        hide: 'true',
        initial: '',
        options: [
          {
            label: 'Select a template',
            value: '',
          }
        ],
        optionsFirstTranslatable: true,
      },
    },
  },
  EIMSTARGET: {
    metadata: {
      layout: {
        rows: [
          [
            'TID',
            'AFID',
          ],
          [
            'NETOPID',
            'SUBNETOPID',
          ],
          [
            'LEAID',
            'WARRANTID',
          ],
          [
            'LEMFID',
            'SUPP_INFO',
          ],
          [
            'USEONELEMF',
          ]
        ],
      },
    },
    fields: {
      TID: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      AFID: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      NETOPID: {
        label: 'Network Operator ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 20,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      SUBNETOPID: {
        label: 'Subnetwork Operator ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 20,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      LEAID: {
        label: 'LEA ID',
        type: 'text',
        initial: 'XCIPIO',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 10,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      WARRANTID: {
        label: 'Warrant ID',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 10,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      LEMFID: {
        label: 'LEMF ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 10,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      USEONELEMF: {
        label: 'Use one LEMF',
        type: 'checkbox',
        initial: false,
      },
      SUPP_INFO: {
        label: 'SUPP INFO',
        type: 'text',
        initial: '',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 5
            },
            {
              type: 'regexp',
              regexp: ['digits'],
              errorMessage:
                'Can only include digits. Please re-enter.'
            },
            {
              type: 'customFunction',
              customValidationFunction: 'shortIntValidator',
              errorMessage: 'Value must be between 0 and 65535.'
            }
          ]
        }
      }
    },
  },
  EIMSWRLNTRGT: {
    metadata: {
      layout: {
        rows: [
          [
            'TID',
            'AFID',
          ],
          [
            'LEGALBASIS',
            'CLOSEUSERGROUP',
          ],
          [
            'NTWKID',
            'NUMSUPPRESSED',
          ],
          [
            'VERIFYMCNB',
            'PABXNAME',
          ],
          [
            'CTYPE',
            'MAXCALL',
          ],
        ],
      },
    },
    fields: {
      TID: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      AFID: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      LEGALBASIS: {
        label: 'Legal Basis',
        type: 'select',
        initial: 'AWG',
        options: [
          {
            label: 'AWG',
            value: 'AWG',
          },
          {
            label: 'G10',
            value: 'G10',
          },
          {
            label: 'STP0',
            value: 'STP0',
          },
        ],
      },
      CLOSEUSERGROUP: {
        label: 'X.25 Close User Group',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5
            },
            {
              type: 'Interval',
              intervals: [[0, 65535]],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.'
            }
          ]
        }
      },
      NTWKID: {
        label: 'X.25 ID',
        type: 'text',
        initial: '',
      },
      NUMSUPPRESSED: {
        label: 'Number Suppression',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      VERIFYMCNB: {
        label: 'MCNB Validation',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      PABXNAME: {
        label: 'PABX Name',
        type: 'text',
        initial: '',
      },
      CTYPE: {
        label: 'CType',
        type: 'select',
        initial: 'ALL',
        options: [
          {
            label: 'ALL',
            value: 'ALL',
          },
          {
            label: 'TERM',
            value: 'TERM',
          },
          {
            label: 'ORIG',
            value: 'ORIG',
          },
        ],
      },
      MAXCALL: {
        label: 'Max Call',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4
            },
            {
              type: 'Interval',
              intervals: [[1, 4095]],
              errorMessage: 'Must be between 1 - 4095. Please re-enter.'
            }
          ]
        }
      },
    },
  },
  EIMSMCNB: {
    metadata: {
      min: 1,
      max: 10,
      layout: {
        rows: [
          [
            'TID',
            'AFID',
          ],
          [
            'MCNBID',
            'MCNB',
          ],
          [
            'MCNBTYPE',
            'MCNBNAME',
          ],
          [
            'SECMASMCNB_ID',
            'DESCRIPTION',
          ],
          [
            'HI3NAME',
            'HOSTNAME',
          ],
          [
            'CHANNELNUM',
            'MCNBPORT',
          ],
        ],
      },
    },
    fields: {
      TID: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      AFID: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      MCNBID: {
        label: 'MCNBID',
        type: 'select',
        initial: '1',
        options: [
          {
            label: '1',
            value: '1',
          },
          {
            label: '2',
            value: '2',
          },
          {
            label: '3',
            value: '3',
          },
          {
            label: '4',
            value: '4',
          },
          {
            label: '5',
            value: '5',
          },
          {
            label: '6',
            value: '6',
          },
          {
            label: '7',
            value: '7',
          },
          {
            label: '8',
            value: '8',
          },
          {
            label: '9',
            value: '9',
          },
          {
            label: '10',
            value: '10',
          },
        ],
      },
      MCNB: {
        label: 'MCNB',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 32,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      MCNBTYPE: {
        label: 'MCNBTYPE',
        type: 'select',
        initial: 'SINGLE',
        options: [
          {
            label: 'SINGLE',
            value: 'SINGLE',
          },
          {
            label: 'MULTIPLE',
            value: 'MULTIPLE',
          },
          {
            label: 'DIVERTED',
            value: 'DIVERTED',
          },
        ],
      },
      MCNBNAME: {
        label: 'MCNBNAME',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 60,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      SECMASMCNB_ID: {
        label: 'Second MCNB ID',
        type: 'text',
        initial: '0',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 10,
            },
            {
              type: 'Interval',
              intervals: [[0, 9999999999]],
              errorMessage: 'Must be between 0 - 9999999999. Please re-enter.',
            },
          ],
        },
      },
      DESCRIPTION: {
        label: 'Description',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 50,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      HI3NAME: {
        label: 'HI3 Name',
        type: 'select',
        initial: 'LIS5-HI3-3GPPr7-Wless-PS_v1',
        options: [
          {
            label: 'LIS5-HI3-3GPPr7-Wless-PS_v0',
            value: 'LIS5-HI3-3GPPr7-Wless-PS_v0',
          },
          {
            label: 'LIS5-HI3-3GPPr7-Wless-PS_v1',
            value: 'LIS5-HI3-3GPPr7-Wless-PS_v1',
          },
          {
            label: 'LIS5-e3-ANSI678-IMS',
            value: 'LIS5-e3-ANSI678-IMS',
          },
          {
            label: 'LIS6-HI3-3GPPr8-Wless-EPS_v1',
            value: 'LIS6-HI3-3GPPr8-Wless-EPS_v1',
          },
          {
            label: 'LIS7-HI3-ETSI232-5',
            value: 'LIS7-HI3-ETSI232-5',
          },
          {
            label: 'LIS13-HI3-3GPPr10-Wless-EPS_v1',
            value: 'LIS13-HI3-3GPPr10-Wless-EPS_v1',
          },
          {
            label: 'LIS13-e3-ATIS0700005a',
            value: 'LIS13-e3-ATIS0700005a',
          },
          {
            label: 'LIS14-HI3-ETSI232-5',
            value: 'LIS14-HI3-ETSI232-5',
          },
          {
            label: 'LIS14-HI3-3GPPr12-VoLTE-Conf',
            value: 'LIS14-HI3-3GPPr12-VoLTE-Conf',
          },
          {
            label: 'LIS16-HI3-ETSI232-5',
            value: 'LIS16-HI3-ETSI232-5',
          },
        ],
      },
      HOSTNAME: {
        label: 'Host Name',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      CHANNELNUM: {
        label: 'Channel Number',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [[0, 65535]],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
          ],
        },
      },
      MCNBPORT: {
        label: 'MCNB Port',
        type: 'text',
        initial: '45001',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [[0, 65535]],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
          ],
        },
      },
    },
  },
};
